import React, { useState } from 'react';
import TypeEffectivenessChart from '../components/TypeEffectivenessChart';
import TypeEffectivenessQuiz from '../components/TypeEffectivenessQuiz';
import NatureChart from '../components/NatureChart';
import './TypeChart.css';

function TypeChart() {
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  return (
    <div className="type-chart-page">
      <h1>Pokémon Charts</h1>
      <p>Learn about type effectiveness and nature effects in Pokémon battles. Test your type matchup knowledge with the quiz!</p>
      
      <div className={`chart-section ${isQuizOpen ? 'blurred' : ''}`}>
        <h2>Type Effectiveness Reference</h2>
        <div className="chart-container">
          <button 
            className="open-quiz-button" 
            onClick={() => setIsQuizOpen(true)}
            aria-label="Open Type Quiz"
          >
            <div className="quiz-button-content">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M9.5 14.5L12 12l2.5 2.5m-5-5L12 12l2.5-2.5M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
              </svg>
              <span>Quiz Mode</span>
            </div>
          </button>
          <TypeEffectivenessChart />
        </div>
      </div>

      <div className={`chart-section ${isQuizOpen ? 'blurred' : ''}`}>
        <NatureChart />
      </div>

      <TypeEffectivenessQuiz isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
    </div>
  );
}

export default TypeChart; 